<div class="nuget-viewer-container"
     data-cy="nuget-viewer-container">
    <ui-workflow-web-viewer [packageName]="context.data.id"
                            [showPackageExplorer]="true"
                            (closeModalEvent)="onClose()">
    </ui-workflow-web-viewer>
</div>
